module.exports = __webpack_public_path__ + "img/ranking5.6c42d3cb.png";